export default __webpack_public_path__ + "static/media/uninstall.8468ddb0.png";